import { InternalRedirection, Option, UrlsLanguagesType } from "../interface";

/**
 * Empty structure hierarchy of submenu
 * Display when menu is pinned and no menu item with submenu as been hovered
 */
export const DEFAULT_SUBMENU_HIERARCHY: Option[] = [
  {
    type: "internalRedirection",
    value: "MENU_DEFAULT",
    name: "MENU_DEFAULT",
    menuLevel: 0,
    toTranslate: true,
  },
];

export const REPORTING_SUBMENU_HIERARCHY: InternalRedirection[] = [
  {
    type: "internalRedirection",
    value: "REPORTING_PERFORMANCE_SUBMENU",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "REPORTING_PERFORMANCE_BOOKING_PAGE_TITLE",
        redirectionTo: "/reporting/",
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "REPORTING_PERFORMANCE_EVENT_PAGE_TITLE",
        redirectionTo: "/events/",
        menuLevel: 1,
        toTranslate: true,
      },
    ],
  },
  {
    type: "internalRedirection",
    value: "REPORTING_BOOKING_SUBMENU",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "REPORTING_BOOKING_BOOKING_PAGE_TITLE",
        redirectionTo: "/reporting/booking/",
        forceAddToMenu: true,
        menuLevel: 1,
        toTranslate: true,
      },
    ],
  },
];

export const MARKETPLACE_MENU_LINKS: UrlsLanguagesType = {
  urlFR: "https://revbell.com/conseil-revenue-management/",
  urlAll: "https://revbell.com/en/services/",
};

export const KNOWLEDGE_BASE_MENU_LINKS: UrlsLanguagesType = {
  urlAll: "https://academy.revbell.com/fr/knowledge-base",
};

/**
 * Structure hierarchy of Marketplace nested menu
 */
export const MARKETPLACE_SUBMENU_HIERARCHY: Option[] = [
  {
    type: "externalRedirection",
    value: "SERVICES",
    urlFR: "https://revbell.com/conseil-revenue-management/",
    urlAll: "https://revbell.com/en/services/",
    menuLevel: 0,
    targetBlank: true,
    toTranslate: true,
    nestedOptions: [
      {
        type: "externalRedirection",
        value: "AUDIT",
        urlFR:
          "https://revbell.com/conseil-revenue-management/service-diagnostic-audit/",
        urlAll: "https://revbell.com/en/services/diagnostic-audit/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "PRICING",
        urlFR: "https://revbell.com/conseil-revenue-management/pricing/",
        urlAll: "https://revbell.com/en/services/pricing/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "INTERIM",
        urlFR: "https://revbell.com/conseil-revenue-management/interim-rm/",
        urlAll: "https://revbell.com/en/services/interim-rm/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "OUTSOURCING",
        urlFR: "https://revbell.com/conseil-revenue-management/outsourcing-rm/",
        urlAll: "https://revbell.com/en/services/outsourcing/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "REVENUE_INTEGRITY",
        urlFR:
          "https://revbell.com/conseil-revenue-management/revenue-integrity/",
        urlAll: "https://revbell.com/en/services/revenue-integrity/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "FORMATION",
        urlFR: "https://revbell.com/conseil-revenue-management/formations/",
        urlAll: "https://revbell.com/en/services/training/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
    ],
  },
  {
    type: "externalRedirection",
    value: "ECOSYSTEM",
    urlFR: "https://revbell.com/ecosysteme/",
    urlAll: "https://revbell.com/en/ecosystem/",
    menuLevel: 0,
    targetBlank: true,
    toTranslate: true,
    nestedOptions: [
      {
        type: "externalRedirection",
        value: "PMS",
        urlFR: "https://revbell.com/ecosysteme-categorie/pms-fr/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/pms/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "CHANNEL_MANAGER",
        urlFR: "https://revbell.com/ecosysteme-categorie/channel-manager/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/channel-manager/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "RATE_SHOPPER",
        urlFR: "https://revbell.com/ecosysteme-categorie/rate-shopper/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/rate-shopper/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "BOOKING_ENGINE",
        urlFR: "https://revbell.com/ecosysteme-categorie/booking-engine/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/booking-engine/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "ASSOCIATION",
        urlFR: "https://revbell.com/ecosysteme-categorie/association/",
        urlAll: "https://revbell.com/ecosysteme-categorie/association/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "ADVICE",
        urlFR: "https://revbell.com/ecosysteme-categorie/conseil-fr/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/consulting/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "CRM",
        urlFR: "https://revbell.com/ecosysteme-categorie/crm/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/crm/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "OTHER_TECH",
        urlFR: "https://revbell.com/ecosysteme-categorie/autre-tech/",
        urlAll: "https://revbell.com/en/ecosysteme-categorie/other-tech/",
        menuLevel: 1,
        targetBlank: true,
        toTranslate: true,
      },
    ],
  },
];

/**
 * Structure of admin submenu
 * We use this to have the structure, but we also compare if module is enable before displaying it.
 * So this is not the final render of the menu, some other transformations are made before displaying
 */
export const ADMIN_SUBMENU_HIERARCHY: InternalRedirection[] = [
  {
    type: "internalRedirection",
    value: "ADMIN_CONNECTION_DATA_SECTION",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "ADMIN_CONNECTIVITY_MENU",
        forceAddToMenu: true,
        isStaff: true,
        menuLevel: 1,
        redirectionTo: `/connectivity`,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        configMenu: true,
        forceAddToMenu: true,
        isStaff: true,
        value: "ADMIN_MODULE_ACTIVATION_MENU",
        menuLevel: 1,
        redirectionTo: `/configuration/setting/batch`,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "ADMIN_EXECUTION_CONSOLE_MENU",
        menuLevel: 1,
        redirectionTo: "/administration/",
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "ADMIN_DATA_HEALTH_MENU",
        isStaff: true,
        forceAddToMenu: true,
        menuLevel: 1,
        redirectionTo: "/administration/data-health/",
        toTranslate: true,
      },
    ],
  },
  {
    type: "internalRedirection",
    value: "ADMIN_IA_NANCIE_SECTION",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "LEARNING_MODELS",
        redirectionTo: "/learning-models/",
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        configMenu: true,
        forceAddToMenu: true,
        isStaff: true,
        value: "GENERAL",
        menuLevel: 1,
        redirectionTo: `/configuration/setting/general`,
        toTranslate: true,
      },
    ],
  },
  {
    type: "internalRedirection",
    value: "ADMIN_GENERAL_CLIENT_SECTION",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "APP_SETTINGS_PAGE",
        redirectionTo: "/settings/",
        menuLevel: 1,
        toTranslate: true,
        useTranslationKey: true,
      },
      {
        type: "internalRedirection",
        value: "ADMIN_MODULE_ACTIVATION_MENU",
        menuLevel: 1,
        redirectionTo: "/modules/",
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "USERS_MENU",
        redirectionTo: "/users/",
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "BLOC_MAIL_SUBMENU",
        redirectionTo: "/configuration/setting/bloc_mail",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
        isStaff: true,
      },
      {
        type: "internalRedirection",
        value: "CUSTOM_KPIS_MENU",
        redirectionTo: "/configuration/setting/custom-kpis",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
        isStaff: true,
      },
    ],
  },
];

/**
 * Structure of Pilotage & Optimisation submenu
 */
export const PILOTAGE_OPTIMISATION_SUBMENU_HIERARCHY: InternalRedirection[] = [
  {
    type: "internalRedirection",
    value: "PILOTAGE_SUBMENU",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "ALERTS_MENU",
        redirectionTo: "/alerte/hebergements/",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "COCKPIT_MENU",
        redirectionTo: "/cockpit/",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
        isNew: true,
      },
      {
        type: "internalRedirection",
        value: "CALENDAR_MENU",
        redirectionTo: "/calendar/",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "WORKFLOW_MENU",
        redirectionTo: "/price/",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
    ],
  },
  {
    type: "internalRedirection",
    value: "AUTOMATISATION_SUBMENU",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "AUTOPILOT",
        redirectionTo: "/configuration/setting/autopilot",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
        flagRequired: "is_active_autopilot",
      },
      {
        type: "internalRedirection",
        value: "BUSINESS_RULES_MENU",
        redirectionTo: "/configuration/setting/business-rules",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
        flagRequired: "is_active_businessrules",
      },
    ],
  },
  {
    type: "internalRedirection",
    value: "STRATEGIE_SUBMENU",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "EVENT_MENU",
        redirectionTo: "/configuration/setting/events",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "MODEL_CONSTRUCTION_MENU",
        redirectionTo: "/configuration/setting/model",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "MODELS_LIBRARY_MENU",
        redirectionTo: "/configuration/setting/models",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "SEASON",
        redirectionTo: "/configuration/setting/seasons",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
    ],
  },
];

/**
 * Structure of Admin Revbell submenu
 */
export const ADMIN_REVBELL_SUBMENU_HIERARCHY: InternalRedirection[] = [
  {
    type: "internalRedirection",
    value: "ADMIN_REVBELL_MENU_GENERAL",
    menuLevel: 0,
    toTranslate: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "BANNER_MENU_LABEL",
        redirectionTo: "/banner/",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "BATCH_STATUS_MENU",
        redirectionTo: "/customers/",
        menuLevel: 1,
        toTranslate: true,
        forceAddToMenu: true,
      },
      {
        type: "internalRedirection",
        value: "EVENT_MASTER_MENU",
        redirectionTo: "/event-master/",
        forceAddToMenu: true,
        isStaff: true,
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "COMPETITOR_MENU",
        redirectionTo: "/sweep/",
        forceAddToMenu: true,
        isStaff: true,
        menuLevel: 1,
        toTranslate: true,
      },
    ],
  },
  {
    type: "internalRedirection",
    value: "ADMIN_REVBELL_MENU_ML_ANALYSIS",
    menuLevel: 0,
    toTranslate: true,
    // Staff on the section too: without it a non-staff user would see the heading with an
    // empty list, both pages being staff-only.
    isStaff: true,
    nestedOptions: [
      {
        type: "internalRedirection",
        value: "REPORTING_ML_ANALYSIS_PAGE_TITLE",
        redirectionTo: "/ml-analysis/",
        forceAddToMenu: true,
        isStaff: true,
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "internalRedirection",
        value: "REPORTING_ML_FORECAST_ANALYSIS_PAGE_TITLE",
        redirectionTo: "/ml-forecast-analysis/",
        forceAddToMenu: true,
        isStaff: true,
        menuLevel: 1,
        toTranslate: true,
      },
    ],
  },
];

/**
 * Structure of support submenu
 */
export const SUPPORT_SUBMENU_HIERARCHY: Option[] = [
  {
    type: "internalRedirection",
    value: "SUPPORT_RESOURCES",
    menuLevel: null,
    toTranslate: true,
    nestedOptions: [
      {
        type: "externalRedirection",
        value: "SUPPORT",
        urlAll: "https://support.revbell.com/tickets-view",
        targetBlank: true,
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "KNOWLEDGE_BASE",
        urlAll: "https://academy.revbell.com/fr/knowledge-base",
        targetBlank: true,
        menuLevel: 1,
        toTranslate: true,
      },
      {
        type: "externalRedirection",
        value: "NEWS",
        urlAll: "https://academy.revbell.com/fr/knowledge-base/nouveautés",
        targetBlank: true,
        menuLevel: 1,
        toTranslate: true,
      },
    ],
  },
];
